import { VALID_NUMBER_LENGTH, VALID_NUMBER_LENGTH_AU } from 'shared/constants/auth'
import { CountryEnum } from 'shared/ui'

export const getIsValidAuthNumber = (value: string, countryCode?: CountryEnum) => {
  const validLength = countryCode === CountryEnum.AU ? VALID_NUMBER_LENGTH_AU : VALID_NUMBER_LENGTH

  return value.replace(/[^\d]/g, '').length === validLength
}
